<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11_623)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.56.268A.913.913 0 1 0 .267 1.559L22.44 23.733a.913.913 0 0 0 1.292-1.292L1.559.268Zm1.225 21.324V5.731l3.311 3.311a.632.632 0 0 0-.168.434c0 .355.304.634.634.634h.602l2.535 2.535H6.435a.628.628 0 0 0-.634.633c0 .355.279.634.634.634h4.53l2.536 2.534H6.435a.628.628 0 0 0-.634.634c0 .355.279.634.634.634h8.333l5.572 5.572c-.367.288-.83.46-1.333.46H4.939a2.153 2.153 0 0 1-2.154-2.154Zm9.784-12.116a.64.64 0 0 1-.084.32l2.849 2.849h.935c.355 0 .634.278.634.633a.627.627 0 0 1-.361.574l4.62 4.62V3.09A2.153 2.153 0 0 0 19.006.934H4.939c-.38 0-.736.098-1.046.27l7.639 7.638h.403c.355 0 .634.28.634.634Z" fill="url(#paint0_linear_11_623)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_11_623"
        x1="0"
        y1="24"
        x2="24"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset=".511" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <clipPath id="clip0_11_623">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>
